// extracted by mini-css-extract-plugin
module.exports = {"areaChart":"style__areaChart___1i5-0"};